import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import Slide, { SlideProps } from '@mui/material/Slide';

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="up" />;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return (
        <MuiAlert
            elevation={8}
            ref={ref}
            variant="filled"
            {...props}
            sx={{
                borderRadius: 2,
                fontSize: '0.9rem',
                fontWeight: 500,
                alignItems: 'center',
                minWidth: 300,
                maxWidth: 500,
                padding: '10px 16px',
                color: '#fff !important',
                '& .MuiAlert-icon': {
                    fontSize: '1.5rem',
                    color: '#fff !important',
                    opacity: 1,
                    marginRight: 1.5,
                    padding: 0,
                },
                '& .MuiAlert-message': {
                    padding: '6px 0',
                    display: 'flex',
                    alignItems: 'center',
                    color: '#fff !important',
                    flex: 1,
                },
                '& .MuiAlert-action': {
                    padding: '0 0 0 12px',
                    marginRight: 0,
                    marginLeft: 0,
                    alignItems: 'center',
                    display: 'flex',
                },
                '& .MuiIconButton-root': {
                    color: '#fff !important',
                    padding: '6px',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    }
                },
                ...props.sx,
            }}
        />
    );
});

export interface DefaultMessageProps {
    message?: string;
    open: boolean;
    onClose?: () => void;
    type?: AlertColor;
}


export default function DefaultMessage(props: DefaultMessageProps) {

    const [defaultMessage, setDefaultMessage] = React.useState<DefaultMessageProps>(props);

    useEffect(() => {
        if (props.open !== undefined)
            setDefaultMessage(props);
    }, [props]);

    const handleClose = () => {
        if (props.onClose !== undefined) {
            props.onClose();
        }
    };

    return (
        <Snackbar
            open={defaultMessage.open}
            autoHideDuration={6000}
            onClose={handleClose}
            TransitionComponent={SlideTransition}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right"
            }}
            sx={{
                bottom: { xs: 16, sm: 24 },
                right: { xs: 16, sm: 24 },
            }}
        >
            <Alert
                onClose={handleClose}
                severity={defaultMessage.type !== undefined ? defaultMessage.type : "success"}
                sx={{
                    width: '100%',
                    whiteSpace: 'pre-line',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                }}
            >
                {defaultMessage.message}
            </Alert>
        </Snackbar>
    );
}
